<template>
  <div id="default-layout">
    <Navbar v-if="loaded"/>
    <div id="menu-content-wrapper" v-if="loaded">
      <Menu v-if="loaded"/>
      <div id="content">
        <confirm-modal/>
        <confirm-with-comment-modal/>
        <router-view v-if="loaded"/>
        <receipt-modal/>
        <customer-form-modal/>
        <pdf-modal/>
        <qr-code-modal/>
        <qr-code-reader/>
        <address-form-modal/>
        <pre-bid-edit-modal/>
        <progress-modal/>
        <audience-modal/>
        <audience-customers-modal/>
        <campaign-modal/>
        <reservation-modal/>
        <customer-reservation-modal/>
        <bidders-modal/>
        <settlement-modal/>
        <bulk-assign-to-sale-modal/>
        <invoice-modal/>
        <continuous-auction-batch-lot-up/>
        <manual-invoice-modal/>
        <bulk-edit-invoice-modal/>
        <financial-item-charge-modal/>
        <note-list-modal/>
        <inventory-bulk-edit-model/>
        <group-items-modal/>
        <grouped-items-reserve-modal/>
        <currency-exchanges-modal/>
        <inventory-misc-charge-modal/>
        <inventory-statuses-modal/>
        <invoice-transaction-exports-modal/>
        <invoice-payment-exports-modal/>
        <service-invoice-modal/>
        <introductory-settlement-modal/>
        <bulk-adjust-price-modal/>
        <relations-modal/>
        <manual-settlement-modal/>
        <inventory-overview-generation-modal/>
        <condition-report-request-modal/>
        <camera-modal/>
        <batch-session-update-modal/>
        <collection-modal/>
        <batch-collection-update-modal/>
        <new-relation-modal/>
        <police-book-generation-modal/>
        <condition-reports-modal/>
        <condition-report-send-modal/>
        <settlement-transaction-exports-modal/>
        <settlement-payment-exports-modal/>
        <auction-results-sync-modal/>
        <bids-modal/>
        <collections-modal/>
        <batch-financial-update-modal/>
        <important-notification-modal/>
        <release-note-modal/>
        <release-notes-list-modal/>
        <lot-info-modal/>
        <proposal-of-unsold-lots-modal/>
        <lot-proposal-edit-modal/>
        <lot-proposal-bulk-edit-modal/>
        <auction-category-term-modal/>
        <transfer-note-modal/>
        <transfer-note-item-modal/>
        <allocate-payment-modal/>
        <invoice-batch-payment-modal/>
        <payment-form-modal/>
        <settlement-payment-form-modal/>
        <settlement-batch-payment-modal/>
        <artisio-table-selection-modal/>
        <batch-telephone-bid-generation-modal/>
        <contract-send-modal/>
        <general-contract-modal/>
        <receipt-item-location-modal/>
        <address-modal/>
        <deposit-invoice-modal/>
        <item-location-move-modal/>
        <item-location-modal/>
        <batch-update-receipt-modal/>
      </div>
    </div>
    <spinner class="h-100" show v-if="!loaded" spinner-size="5" :with-text="false"/>
<!--    <support-chat v-if="loaded"/>-->
  </div>
</template>

<script>
  import Navbar from './../../navbar/Navbar';
  import Menu from "./../../menu/Menu";
  import {createNamespacedHelpers} from 'vuex';
  import ConfirmModal from "../../../../plugins/confirm-modal/ConfirmModal";
  import ReceiptModal from "../../../../modules/receipt/ReceiptModal";
  import PdfModal from "../../pdf-modal/PdfModal";
  import CustomerFormModal from "../../../../modules/customer/CustomerFormModal";
  import AddressFormModal from "../../../../modules/customer/view/addresses/AddressFormModal";
  import PreBidEditModal from "../../../../modules/pre-bids/modals/PreBidEditModal.vue";
  import QrCodeModal from "../../qr-code-generator/QrCodeModal";
  import QrCodeReader from "../../qr-code-generator/QrCodeReader";
  import ProgressModal from "@/core/components/progress-modal/ProgressModal";
  import AudienceModal from "@/modules/marketing/audience/AudienceModal";
  import AudienceCustomersModal from "@/modules/marketing/audience/AudienceCustomersModal";
  import CampaignModal from "@/modules/marketing/audience/campaign/CampaignModal";
  import ReservationModal from "@/modules/lots/modals/ReservationModal.vue";
  import CustomerReservationModal from "../../../../modules/customer/view/balance/CustomerReservationModal";
  import Spinner from "@/core/components/common/Spinner";
  import {
    WS_AUCTION_CATALOG_GENERATION_PROGRESS, WS_AUCTIONEERS_SHEET_GENERATION_PROGRESS,
    WS_AUCTION_CSV_EXPORT_FINISH,
    WS_AUCTION_PDF_EXPORT_FINISH, WS_AUCTION_SALE_PROFILE_PDF_EXPORT_FINISH, WS_AUCTION_AUCTIONEERS_BOOK_EXPORT_FINISH,
    WS_AUCTION_XLSX_EXPORT_FINISH,
    WS_EXPORT,
    WS_INVENTORY_OVERVIEW_GENERATION_PROGRESS,
    WS_LIVE_AUCTION_SYNC_PROGRESS,
    WS_REPORT,
    WS_KEEP_ALIVE,
    ACTION_LOT_EXPORT_ALL_IMAGES,
    ACTION_INVENTORY_EXPORT_IMAGES,
    WS_BULK_EDIT_TEMPLATE_EXPORT_FINISH,
  } from "@/modules/constants";
  import BiddersModal from "../../../../modules/bidders/BiddersModal";
  import SettlementModal from "@/modules/settlements/SettlementModal";
  import InvoiceModal from "@/modules/invoices/InvoiceModal";
  import InvoiceTransactionExportsModal from "@/modules/invoices/InvoiceTransactionExportsModal.vue"
  import InvoicePaymentExportsModal from "@/modules/invoices/InvoicePaymentExportsModal.vue"
  import BulkAssignToSaleModal from "@/modules/inventory/bulk-assign-to-sale-modal/BulkAssignToSaleModal";
  import ContinuousAuctionBatchLotUp
    from "@/modules/inventory/continuous-auction-batch-lot-up-modal/ContinuousAuctionBatchLotUp";
  import ManualInvoiceModal from "@/modules/invoices/ManualInvoiceModal";
  import FinancialItemChargeModal from "@/modules/reservations/view/sale-settings/modals/FinancialItemChargeModal";
  import NoteListModal from "@/modules/notes/NoteListModal";
  import InventoryBulkEditModel from "../../../../modules/inventory/InventoryBulkEditModal";
  import GroupItemsModal from "@/modules/inventory/group-items/GroupItemsModal";
  import GroupedItemsReserveModal from "@/modules/inventory/group-items/GroupedItemsReserveModal";
  import CurrencyExchangesModal from "@/modules/sales/view/terms/modals/CurrencyExchangesModal";
  import InventoryMiscChargeModal
    from "@/modules/inventory/view/dashboard/inventory-misc-charges/InventoryMiscChargeModal";
  import {
    onAuctionCatalogGenerationFinish, onAuctionFileExportFinish,
    onExportFinish, onExportLotImagesFinish, onInventoryOverviewGenerationFinish,
    onReportFinish, onAuctioneersSheetGenerationFinish, onBulkEditTemplateExportFinish
  } from "@/plugins/vue-native-websocket/socketListeners.service";
  import InventoryStatusesModal from "@/modules/inventory/InventoryStatusesModal";
  import ServiceInvoiceModal from "@/modules/invoices/ServiceInvoiceModal";
  import IntroductorySettlementModal from "@/modules/settlements/IntroductorySettlementModal";
  import BulkAdjustPriceModal from "@/modules/lots/bulk-adjust-price/BulkAdjustPriceModal.vue";
  import RelationsModal from "@/modules/customer/view/dashboard/relations/RelationsModal";
  import ManualSettlementModal from "@/modules/settlements/ManualSettlementModal";
  import InventoryOverviewGenerationModal
    from "@/modules/inventory/inventory-overview-generation-modal/InventoryOverviewGenerationModal";
  import BatchSessionUpdateModal from "@/modules/lots/batch-session-update-modal/BatchSessionUpdateModal";
  import CollectionModal from "@/modules/sales/view/collections/CollectionModal";
  import BatchCollectionUpdateModal from "@/modules/lots/batch-collection-update-modal/BatchCollectionUpdateModal";
  import AuctionCategoryTermModal from "@/modules/sales/view/terms/modals/AuctionCategoryTermModal";
  import PoliceBookGenerationModal from "@/modules/police-books/PoliceBookModal.vue";

  // do not remove following import
  import adapter from 'webrtc-adapter';
  import CameraModal from "@/core/components/camera/CameraModal";
  import ConditionReportsModal from "@/modules/condition-reports/ConditionReportsModal.vue";
  import ConditionReportSendModal from "@/modules/condition-report-requests/ConditionReportSendModal.vue";
  import AuctionResultsSyncModal from "@/modules/lots/auction-results-sync-modal/AuctionResultsSyncModal";

  import NewRelationModal from "@/modules/relations/NewRelationModal";
  import SettlementTransactionExportsModal from "@/modules/settlements/SettlementTransactionExportsModal.vue";
  import SettlementPaymentExportsModal from "@/modules/settlements/SettlementPaymentExportsModal.vue";
  import BidsModal from "@/modules/bids/BidsModal.vue";
  import CollectionsModal from "@/modules/collections/CollectionsModal";
  import ConditionReportRequestModal
    from "@/modules/inventory/condition-report-request-modal/ConditionReportRequestModal.vue";
  import BatchFinancialUpdateModal from "@/modules/lots/batch-financial-update/BatchFinancialUpdateModal";
  import ImportantNotificationModal from "@/core/components/layout/DefaultLayout/ImportantNotificationModal";
  import BulkEditInvoiceModal from "@/modules/invoices/BulkEditInvoiceModal.vue";
  import ReleaseNoteModal from "@/core/components/layout/DefaultLayout/ReleaseNoteModal.vue";
  import ReleaseNotesListModal from "@/core/components/layout/DefaultLayout/ReleaseNotesListModal.vue";
  import LotInfoModal from "@/modules/lots/clickable-lot-no/LotInfoModal";
  import ProposalOfUnsoldLotsModal from "@/modules/vendors/ProposalOfUnsoldLotsModal.vue";
  import LotProposalEditModal from "@/modules/vendors/LotProposalEditModal.vue";
  import LotProposalBulkEditModal from "@/modules/vendors/LotProposalBulkEditModal.vue";
  import TransferNoteModal from "@/modules/transfer-notes/TransferNoteModal";
  import TransferNoteItemModal from "@/modules/transfer-notes/TransferNoteItemModal";
  import AllocatePaymentModal from "@/modules/invoices/allocate-payment/AllocatePaymentModal";
  import InvoiceBatchPaymentModal from "@/modules/invoices/invoice-batch-payment/InvoiceBatchPaymentModal";
  import PaymentFormModal from "@/modules/invoices/PaymentFormModal";
  import SettlementPaymentFormModal from "@/modules/settlements/SettlementPaymentFormModal";
  import SettlementBatchPaymentModal from "@/modules/settlements/settlement-batch-payment/SettlementBatchPaymentModal";
  import ArtisioTableSelectionModal from "@/core/components/ams-table/ArtisioTableSelectionModal";
  import BatchTelephoneBidGenerationModal from "@/modules/pre-bids/modals/BatchTelephoneBidGenerationModal";
  import ContractSendModal from "@/modules/contracts/ContractSendModal";
  import GeneralContractModal from "@/core/components/general-contract-modal/GeneralContractModal.vue";
  import ReceiptItemLocationModal from "@/modules/receipt/ReceiptItemLocationModal.vue";
  import AddressModal from "@/core/components/address-modal/AddressModal";
  import DepositInvoiceModal from "@/modules/invoices/DepositInvoiceModal.vue";
  import ItemLocationMoveModal from "@/core/components/item-location-move-modal/ItemLocationMoveModal.vue";
  import ItemLocationModal from "@/modules/setup/branch/tabs/item-locations/ItemLocationModal.vue";
  import BatchUpdateReceiptModal from "@/modules/inventory/batch-update-receipt/BatchUpdateReceiptModal";
  import ConfirmWithCommentModal from "@/plugins/confirm-with-comment-modal/ConfirmWithCommentModal.vue";
  // import SupportChat from "@/core/components/support-chat/SupportChat.vue";

  const {mapActions: globalActions, mapState} = createNamespacedHelpers('global');
  const {mapMutations: saleMapMutations} = createNamespacedHelpers('sales');
  export default {
    name: "DefaultLayout",
    components: {
      // SupportChat,
      ItemLocationModal,
      BatchUpdateReceiptModal,
      ItemLocationMoveModal,
      GeneralContractModal,
      ContractSendModal,
      DepositInvoiceModal,
      AddressModal,
      ConfirmWithCommentModal,
      BatchTelephoneBidGenerationModal,
      ArtisioTableSelectionModal,
      TransferNoteItemModal,
      TransferNoteModal,
      AllocatePaymentModal,
      SettlementBatchPaymentModal,
      SettlementPaymentFormModal,
      PaymentFormModal,
      InvoiceBatchPaymentModal,
      LotInfoModal,
      BulkEditInvoiceModal,
      ReleaseNotesListModal,
      ReleaseNoteModal,
      LotProposalBulkEditModal,
      LotProposalEditModal,
      ProposalOfUnsoldLotsModal,
      ImportantNotificationModal,
      BatchFinancialUpdateModal,
      ConditionReportRequestModal,
      CollectionsModal,
      ConditionReportSendModal,
      ConditionReportsModal,
      AuctionResultsSyncModal,
      BidsModal,
      AuctionCategoryTermModal,
      CameraModal,
      BatchCollectionUpdateModal,
      CollectionModal,
      NewRelationModal,
      BatchSessionUpdateModal,
      InventoryOverviewGenerationModal,
      ManualSettlementModal,
      RelationsModal,
      BulkAdjustPriceModal,
      IntroductorySettlementModal,
      ServiceInvoiceModal,
      CurrencyExchangesModal,
      InventoryMiscChargeModal,
      InventoryStatusesModal,
      NoteListModal,
      FinancialItemChargeModal,
      SettlementModal,
      InvoiceModal,
      InvoiceTransactionExportsModal,
      InvoicePaymentExportsModal,
      ManualInvoiceModal,
      ContinuousAuctionBatchLotUp,
      GroupedItemsReserveModal,
      GroupItemsModal,
      BulkAssignToSaleModal,
      BiddersModal,
      InventoryBulkEditModel,
      Spinner,
      CustomerReservationModal,
      ReservationModal,
      CampaignModal,
      AudienceCustomersModal,
      AudienceModal,
      QrCodeReader,
      QrCodeModal,
      PreBidEditModal,
      AddressFormModal,
      CustomerFormModal,
      PdfModal,
      ReceiptModal,
      ConfirmModal,
      ProgressModal,
      Menu,
      Navbar,
      PoliceBookGenerationModal,
      SettlementTransactionExportsModal,
      SettlementPaymentExportsModal,
      ReceiptItemLocationModal,
    },
    data() {
      return {
        interval: null
      }
    },
    methods: {
      ...globalActions(['initGlobals', 'updateWarning', 'initIdleTracker', 'updateSocketLastInteractionTime']),
      ...saleMapMutations(['addSaleSyncProgress']),
      isTouchDevice() {
        const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints;
        document.getElementById('app').className = isTouch ? 'touch' : 'no-touch';
      },
      checkSocketConnection() {
        const interval = 5000;
        this.interval = setInterval(() => {
          if (this.socketLastInteractionTime && new Date().getTime() - this.socketLastInteractionTime > 30000) {
            this.updateSocketLastInteractionTime()
            this.isSocketConnected && this.$ws.sendObj({}, WS_KEEP_ALIVE)
          }
        }, interval);
      },
    },
    computed: {
      ...mapState(['loaded', 'warning', 'idleTimeoutMilliseconds', 'socketLastInteractionTime', 'isSocketConnected']),
    },
    async mounted() {
      this.checkSocketConnection()

      // Listen on socket and save data in vuex to recover it later in sales view
      this.$ws.listen(`auctions.${WS_LIVE_AUCTION_SYNC_PROGRESS}`, (data) => this.addSaleSyncProgress(data));
      this.$ws.listen(`reports.${WS_REPORT}`, (data) => onReportFinish(this, data));
      this.$ws.listen(`common.${WS_EXPORT}`, (data) => onExportFinish(this, data))
      this.$ws.listen(`common.${ACTION_LOT_EXPORT_ALL_IMAGES}`, (data) => onExportLotImagesFinish(this, data))
      this.$ws.listen(`common.${ACTION_INVENTORY_EXPORT_IMAGES}`, (data) => onExportLotImagesFinish(this, data))
      this.$ws.listen(`auctions.${WS_AUCTION_CATALOG_GENERATION_PROGRESS}`, (data) => onAuctionCatalogGenerationFinish(this, data));
      this.$ws.listen(`auctions.${WS_INVENTORY_OVERVIEW_GENERATION_PROGRESS}`, (data) => onInventoryOverviewGenerationFinish(this, data));
      this.$ws.listen(`auctions.${WS_AUCTION_CSV_EXPORT_FINISH}`, (data) => onAuctionFileExportFinish(this, data, 'csv'));
      this.$ws.listen(`auctions.${WS_AUCTION_PDF_EXPORT_FINISH}`, (data) => onAuctionFileExportFinish(this, data, 'pdf'));
      this.$ws.listen(`auctions.${WS_AUCTION_XLSX_EXPORT_FINISH}`, (data) => onAuctionFileExportFinish(this, data, 'xlsx'));
      this.$ws.listen(`auctions.${WS_AUCTION_SALE_PROFILE_PDF_EXPORT_FINISH}`, (data) => onAuctionFileExportFinish(this, data, 'auction_sale_profile_pdf'));
      this.$ws.listen(`auctions.${WS_AUCTION_AUCTIONEERS_BOOK_EXPORT_FINISH}`, (data) => onAuctionFileExportFinish(this, data, 'auction_auctioneers_book'));
      this.$ws.listen(`auctions.${WS_AUCTIONEERS_SHEET_GENERATION_PROGRESS}`, (data) => onAuctioneersSheetGenerationFinish(this, data));
      this.$ws.listen(`common.${WS_BULK_EDIT_TEMPLATE_EXPORT_FINISH}`, (data) => onBulkEditTemplateExportFinish(this, data));

      this.isTouchDevice();
      await this.initGlobals();
      this.initIdleTracker();
      this.$ws.connect();
      if (this.warning) {
        this.$toast('error', this.warning);
        this.updateWarning(null);
      }



    },
    beforeDestroy() {
      this.$ws.remove(`auctions.${WS_LIVE_AUCTION_SYNC_PROGRESS}`);
      this.$ws.remove(`reports.${WS_REPORT}`);
      this.$ws.remove(`common.${WS_EXPORT}`);
      this.$ws.remove(`auctions.${WS_AUCTION_CATALOG_GENERATION_PROGRESS}`);
      this.$ws.remove(`auctions.${WS_INVENTORY_OVERVIEW_GENERATION_PROGRESS}`);
      this.$ws.remove(`auctions.${WS_AUCTIONEERS_SHEET_GENERATION_PROGRESS}`);
      this.$ws.disconnect()
    }
  }
</script>

<style lang="scss">
  @import "./../../../scss/variables";
  @import "./../../../scss/touch-screen";

  .search-form {
    .input-wrapper {
      width: 225px;
      padding: 0 0 0 .5rem;

      .form-group {
        margin-bottom: .5rem;
      }
    }

    .search-btn-wrapper {
      margin-left: auto;
      min-width: auto;
      white-space: nowrap;
      padding-left: 10px;
    }
  }

  #default-layout {
    height: $default-layout-height;
    display: flex;
    flex-direction: column;


    #menu-content-wrapper {
      display: flex;
      flex: 1;
      overflow: hidden;

      #content {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: auto;
        position: relative;

        .page {
          display: flex;
          flex-direction: column;
          overflow: hidden;

          > .content-wrapper {
            overflow: auto;
          }

          .table-component {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow: hidden;

            .artisio-table {
              flex: 1;
              display: flex;
              flex-direction: column;
              overflow: hidden;

              .table-content {
                display: flex;
                overflow: auto;
              }

              .pagination {
                margin-bottom: 0;
              }
            }
          }

          &.page-with-table {
            background-color: $secondary;
            height: calc(100%);
            overflow-y: auto;
            position: relative;

            > .content-wrapper {
              overflow: hidden;
              display: flex;
              flex-direction: column;
            }
          }

          &.page-with-tabs {
            flex: 1;
            display: flex;
            flex-direction: column;
            background-color: $secondary;
            overflow: hidden;

            > .content-wrapper {
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .tab-content {
                flex: 1;
                overflow-x: hidden;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
              }

              .tab-table {
                display: flex;
                flex-direction: column;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }

  .inventory-statuses-popover {
    .popover-body {
      font-size: .85rem !important;
    }
  }

</style>
